var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"request-data"},[_c('dt',{staticClass:"request-data__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('dd',{staticClass:"request-data__value"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }